export const DEFAULT_LABEL = 'Default Label'
